<ng-container *ngIf="reservationDurations?.length > 0; else noResultBlock">
    <ion-card [class.ghost]="ghostMode"
              class="card-grey">
        <ion-card-header>
            <ion-card-title>
                {{'charge.reservationChoice.label' | translate}}<span class="required">*</span>
            </ion-card-title>
        </ion-card-header>

        <ion-card-content>
            <ion-item (click)="selectReservationDuration(null)"
                      [class.selected]="isSelected(null)"
                      class="plugPath charge"
                      tappable>
                <div class="medium-ghost-size">
                    <span class="ghost-hidden">
                        {{'charge.reservationChoice.noReservation' | translate}}
                    </span>
                </div>
            </ion-item>
            <ion-item (click)="selectReservationDuration(duration)"
                      *ngFor="let duration of reservationDurations; trackBy: trackByDuration"
                      [class.selected]="isSelected(duration)"
                      class="plugPath charge"
                      tappable>
                <div class="duration">
                    <div class="duration-time small-ghost-size">
                        <span class="ghost-hidden">
                        {{duration?.durationInMinutes | duration :{report: true, minutes: true, seconds: false, entryUnit: 'm'} }}
                    </span>
                    </div>
                    <div class="duration-price small-ghost-size">
                        <span class="ghost-hidden">
                        {{duration?.price?.priceWithVAT | currency:undefined: duration?.price?.currencyUnit}}
                    </span>
                    </div>
                </div>
            </ion-item>
        </ion-card-content>
    </ion-card>

    <izivia-help-text>{{'charge.reservationChoice.description' | translate}}</izivia-help-text>
</ng-container>

<ng-template #noResultBlock>
    <ion-card class="card-grey reservationEmpty">
        <ion-card-content>
            <div>
                <ion-item>{{'charge.reservationChoice.noChoice' | translate}}</ion-item>
            </div>
        </ion-card-content>
    </ion-card>
</ng-template>
